import { render, staticRenderFns } from "./folder.vue?vue&type=template&id=14c52ed5&scoped=true"
import script from "./folder.vue?vue&type=script&lang=ts"
export * from "./folder.vue?vue&type=script&lang=ts"
import style0 from "./folder.vue?vue&type=style&index=0&id=14c52ed5&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14c52ed5",
  null
  
)

export default component.exports